import React from 'react';
import { OrganisationStore } from 'stores/private/OrganisationStore';
import { inject, observer } from 'mobx-react';
import './OrganisationPrivacy.scss';

import { UsersStore } from 'stores/private/UsersStore';
import PageContainer from 'components/PageContainer/PageContainer';
import { PageHeadLine } from 'components/PageHeadLine/PageHeadLine';
import PageContent from 'components/PageContent/PageContent';
import LinkButton from 'components/LinkButton/LinkButton';
import { ampli } from 'ampli';

interface OrganisationPrivacyProps {
  organisationStore?: OrganisationStore;
  usersStore?: UsersStore;
}
const OrganisationPrivacy = ({
  organisationStore,
  usersStore,
}: OrganisationPrivacyProps) => {
  const organisation = organisationStore?.currentOrganisation;

  if (!organisation) {
    return null;
  }

  return (
    <PageContainer>
      <PageHeadLine title="Privacy documents" />
      <PageContent hasTitle isMediumBoxed>
        <div className="options-group">
          <div className="options-group-header">Privacy documents</div>
          <div className="danger-zone">
            <div className="danger-zone-container">
              <div className="danger-zone-item">
                <div className="danger-zone-label">Data processing agreement</div>
                <LinkButton
                  iconSideRight={false}
                  icon="file-shield"
                  label="Request"
                  onClick={() => {
                    window.open('mailto:hello@gleap.io', '_blank');

                    ampli.dpaRequested();
                  }}
                />
              </div>
              <div className="danger-zone-item">
                <div className="danger-zone-label">Privacy policy</div>
                <LinkButton
                  iconSideRight={false}
                  icon="shield-halved"
                  label="Show"
                  onClick={() => {
                    window.open('https://gleap.io/privacy-policy/', '_blank');

                    ampli.privacyPolicyViewed();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </PageContent>
    </PageContainer>
  );
};

export default inject(
  'organisationStore',
  'usersStore',
)(observer(OrganisationPrivacy));
